import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="gym-floor relative w-full text-white" data-id="element-55" data-mp="1zyh2w7skw2x2">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-56" data-mp="1uy2vmryswx03" />
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-57" data-mp="1v0fmjumjehpa">
        <h2 className="font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-58" data-mp="1pyq9yajo1vz3">
          Stop planning from scratch. <span className="italic text-amber" data-id="element-59" data-mp="1l1gfgghf6u4e">Start walking in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-60" data-mp="1g7vq1ctw78gt">
          Six volumes, 60+ class plans and five bonuses. A full year of aerial
          classes — silks, hoop and trapeze, every skill at three levels,
          printable and ready to teach.
        </p>

        <div className="mt-7" data-id="element-61" data-mp="128m8o9tya8b9">
          <Countdown size="sm" tone="dark" data-id="element-62" data-mp="128vwprvfq5eb" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber bg-ink-deep/60 px-5 py-4 text-left" data-id="element-63" data-mp="xaaxnvrx5rrg">
          <div data-id="element-64" data-mp="40r4dm7br86t">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-amber" data-id="element-65" data-mp="4198t6454spt">Complete package</span>
            <span className="text-[15px] font-semibold text-white" data-id="element-66" data-mp="3lia96y08r2hf">Aerial Class Ready — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-67" data-mp="3qgljtayd1h0p">
            <span className="text-[15px] text-white/60 line-through" data-id="element-68" data-mp="i08xuevkf9mi">$97</span>
            <span className="font-display text-4xl font-bold leading-none text-white" data-id="element-69" data-mp="mzbpmxmjbjcj">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-70" data-mp="81azkk8c81qb">
          <CtaButton data-id="element-71" data-mp="84p2btkwycya">Yes, I want to walk in ready — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-72" data-mp="czkwaz9pnae1">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-73" data-mp="2xsg26x2ls853">
              <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-74" data-mp="149flnwc78jnk" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}